import { OPPORTUNITY_LIFECYCLE_STEPS, getLifecycleStepIndex } from "../../../store/admin/investorPortal/opportunityLifecycle";
import { convertToTitleCase } from "../../../utils/helpers";

export default function AdminLifecycleStepper({ status, steps, getStepIndex }) {
  const lifecycleSteps = steps || OPPORTUNITY_LIFECYCLE_STEPS;
  const activeIndex = getStepIndex ? getStepIndex(status) : getLifecycleStepIndex(status);

  return (
    <div className="admin-lifecycle-stepper" role="list" aria-label="Lifecycle">
      {lifecycleSteps.map((step, index) => {
        const isComplete = index < activeIndex;
        const isCurrent = index === activeIndex;
        return (
          <div
            key={step.key}
            role="listitem"
            className={`admin-lifecycle-step${isCurrent ? " admin-lifecycle-step--current" : ""}${isComplete ? " admin-lifecycle-step--complete" : ""}`}
          >
            <div className="admin-lifecycle-step-dot" aria-hidden="true">
              {isComplete ? "✓" : index + 1}
            </div>
            <span className="admin-lifecycle-step-label">{step.label}</span>
            {index < lifecycleSteps.length - 1 ? (
              <div className="admin-lifecycle-step-line" aria-hidden="true" />
            ) : null}
          </div>
        );
      })}
      <p className="text-muted small mb-0 mt-2">
        Current status: <strong>{convertToTitleCase(String(status || "").replace(/_/g, " "))}</strong>
      </p>
    </div>
  );
}
